import { Address } from './address/address';
import { ClientDetails } from './client/client-details';
import { ProviderDetails } from './provider/provider-details';
import { Representative } from './representative/representative';

export interface SiteProperties {
  siteId: string;
  businessTypes: number[];
}

export interface Business {
  addresses?: Address[];
  aliases?: string[];
  businessTypes: number[];
  siteIds?: string[];
  siteProperties?: SiteProperties[];
  clientDetails?: ClientDetails;
  code?: string;
  createdBy?: string;
  createdDate?: string;
  id?: string;
  leadAssociateUserName?: string;
  lotNumbers?: string[];
  modifiedBy?: string;
  modifiedDate?: string;
  name: string;
  providerDetails?: ProviderDetails;
  representatives?: Representative[];
  taxIndicatorCode?: string;
  /** ISO-3166 alpha-3 country where the business is located (#5121), e.g. `HND`. Required by the API,
   *  which validates it against the same catalog `/countries` serves. */
  countryCode?: string;
}

/** One entry in the ISO-3166 catalog served by `GET /countries` (#5121). */
export interface Country {
  code: string;
  name: string;
}

export interface BusinessSearchCommand {
  name?: string;
  code?: string;
  businessTypes?: number[];
}

export enum BusinessEntityType {
  Provider,
  Client,
  Manufacturer,
  Consignee,
  Brand,
  InternalCompany,
  /** Current-expense vendor (gasto corriente): petty cash and trip receipts (#5776). */
  CurrentExpense = 6,
}
